/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, month: NonNullable<unknown>, year: NonNullable<unknown> }} Receipt_DateInputs */

const vi_receipt_date = /** @type {(inputs: Receipt_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ngày ${i?.day} tháng ${i?.month} năm ${i?.year}`)
};

/**

* @param {Receipt_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_date = /** @type {((inputs: Receipt_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_DateInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_date(inputs)
});